module.exports = __webpack_public_path__ + "img/basicIcon.f6c8a8a1.png";